import { useAuth } from "hooks/useAuth";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoute";


interface AdminRouteProps {
    children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {

    const [{ isAdmin }] = useAuth();

    return isAdmin ? (
        <ProtectedRoute>
            {children}
        </ProtectedRoute>
    ) : (
        <Navigate to={"/"} />
    );
};

export default AdminRoute;
